import React, { useState } from "react";
import { Button, Menu, MenuItem, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { PAGE_SIZE } from "../../services";
const PAGE_SIZE_PARAM_NAME = "pageSize";
export const PageSizeFilter = ({ navigate, params }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleChange = (event) => {
        navigate(Object.assign(Object.assign({}, params), { 
            // if we asking for default page size, then just clear out the parameter
            [PAGE_SIZE_PARAM_NAME]: event.target.value === String(PAGE_SIZE) ? undefined : event.target.value, page: undefined }));
    };
    const pageSize = params[PAGE_SIZE_PARAM_NAME] || PAGE_SIZE;
    return (React.createElement("span", null,
        "\u00A0",
        React.createElement(Button, { "aria-controls": "page-size-filter", "data-test": "page-size-filter", "aria-haspopup": "true", onClick: handleMenuOpen, className: "PagerPageSize" }, pageSize),
        React.createElement(Menu, { getContentAnchorEl: null, anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "center",
            }, id: "page-size-filter", anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleMenuClose, className: "UserMenu" },
            React.createElement(RadioGroup, { "aria-label": "status", name: "status", value: pageSize, onChange: handleChange },
                React.createElement(MenuItem, null,
                    React.createElement(FormControlLabel, { value: PAGE_SIZE, control: React.createElement(Radio, null), label: PAGE_SIZE })),
                React.createElement(MenuItem, null,
                    React.createElement(FormControlLabel, { value: "20", "data-test": "data-test=items-per-page-selector-50", control: React.createElement(Radio, null), label: "20" })),
                React.createElement(MenuItem, null,
                    React.createElement(FormControlLabel, { value: "100", "data-test": "data-test=items-per-page-selector-100", control: React.createElement(Radio, null), label: "100" }))))));
};
